import dayjs from 'dayjs';
import {
  IEnvironmentMeta,
  EnvironmentStatistics
} from 'modules/environment/models/environment.model';

// time 포맷팅을 위한 헬퍼 함수(원하는 형식으로 구현)
function formatTimeToString(date: Date): string {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
}

/**
 * weather 전용
 * IEnvironmentMeta 배열을 받아 WeatherStatistics 형태로 변환
 * @param resultList IEnvironmentMeta[]
 * @returns WeatherStatistics
 */
export const formatWeatherStatistics = (resultList: IEnvironmentMeta[]): EnvironmentStatistics => {
  // WeatherStatistics 구조에 맞춰 초기값 설정
  const formatStatistics: EnvironmentStatistics = {
    time: [],
    temperatureAir: [],
    windDirection: [],
    windSpeed: [],
    maxWindSpeed: [],
    humidity: [],
    barometer: [],
    rain: [],
    heatIndex: [],
    pm2_5: [],
    pm10: []
  };

  resultList.forEach((statistics) => {
    // time은 string으로 변환
    const date = new Date(statistics.time);
    formatStatistics.time.push(formatTimeToString(date));

    // 나머지 값들은 number이므로 그대로 푸시
    formatStatistics.temperatureAir.push(statistics.temperatureAir);
    formatStatistics.windDirection.push(statistics.windDirection);
    formatStatistics.windSpeed.push(statistics.windSpeed);
    formatStatistics.maxWindSpeed.push(statistics.maxWindSpeed);
    formatStatistics.humidity.push(statistics.humidity);
    formatStatistics.barometer.push(statistics.barometer);
    formatStatistics.rain.push(statistics.rain);
    formatStatistics.heatIndex.push(statistics.heatIndex);
    formatStatistics.pm2_5.push(statistics.pm2_5);
    formatStatistics.pm10.push(statistics.pm10);
  });

  return formatStatistics;
};
